import { setSortingFunction } from 'utils/actions/table-sorting/table-sorting.actions';

const SORT_DIRECTION = {
  asc: 'true',
  desc: 'false',
};

const mapStateToThis = ({ ui }) => {
  const { sortingFunction } = ui;
  return {
    sortingFunction,
  };
};

const mapDispatchToThis = {
  setSortingFunction,
};

@Inject('$ngRedux')
export class TableColumnController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  setSortDirection(column) {
    return this.sortingFunction[column.field] === SORT_DIRECTION.asc ? SORT_DIRECTION.desc : SORT_DIRECTION.asc;
  }

  changeSorting(column) {
    if (!column.sortable) return;

    this.setSortingFunction({
      [column.field]: this.setSortDirection(column),
    });

    return this.sortBy({
      column: column.field,
      direction: this.sortingFunction[column.field],
    });
  }
}


// WEBPACK FOOTER //
// ./src/modules/utils/grid/table-column-controller.js